import { render } from "./DownloadLogsFilePopover.vue?vue&type=template&id=50cf0bb0&ts=true"
import script from "./DownloadLogsFilePopover.vue?vue&type=script&lang=ts"
export * from "./DownloadLogsFilePopover.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__